module.exports = __webpack_public_path__ + "static/best-thing-24f8b859601812134b9350cd1f443bb4.webp";